import { render, staticRenderFns } from "./messagelist.vue?vue&type=template&id=90566964&scoped=true"
import script from "./messagelist.vue?vue&type=script&lang=js"
export * from "./messagelist.vue?vue&type=script&lang=js"
import style0 from "./messagelist.vue?vue&type=style&index=0&id=90566964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90566964",
  null
  
)

export default component.exports